import { render } from "./PaymentOrderFormView.vue?vue&type=template&id=5573bd66"
import script from "./PaymentOrderFormView.vue?vue&type=script&lang=js"
export * from "./PaymentOrderFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__